import { LitElement, html, svg } from 'lit';

export class IconDownload16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Pil ned til harddisk</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 2v8M5 7l3 3 3-3M1 11v.931c0 .549.197 1.075.547 1.463.35.388.825.606 1.32.606h10.266c.495 0 .97-.218 1.32-.606.35-.388.547-.914.547-1.463V11"></path></svg>`; }
}
if (!customElements.get('f-icon-download16', IconDownload16)) {
  customElements.define('f-icon-download16', IconDownload16);
}